var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 19.207,
    viewBox: "0 0 16.5 19.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-minus-alt-svgrepo-com",
    d: "M13,3H8.2a4.969,4.969,0,0,0-2.108.218,2,2,0,0,0-.874.874A4.969,4.969,0,0,0,5,6.2V17.8a4.969,4.969,0,0,0,.218,2.108,2,2,0,0,0,.874.874A4.968,4.968,0,0,0,8.2,21H12M13,3l6,6M13,3V7.4a2.484,2.484,0,0,0,.109,1.054,1,1,0,0,0,.437.437A2.484,2.484,0,0,0,14.6,9H19m0,0v5.5M9,17h2.5M9,13h6M9,9h1m5.5,9.5h5",
    transform: "translate(-4.5 -2.293)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBlk);
export default __webpack_public_path__ + "static/media/summary_blk.4f42cb9500027ad3947a81c5e172a060.svg";
export { ForwardRef as ReactComponent };